var _defs, _path, _rect, _path2, _path3, _rect2, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _rect3, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYildizHolding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 247.522,
    height: 20.58,
    viewBox: "0 0 247.522 20.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247.522,
    height: 20.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.707,
    height: 3.336,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.851,22.976c-1.142-.8-3.805-2.766-3.805-2.766h20.707s-13.725,4.987-16.9,2.766",
    transform: "translate(-254.046 -20.21)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -4.782,
    y1: 2.544,
    x2: -4.763,
    y2: 2.544,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1818"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.455,8.044l-3.5,8.431H7.822L6.417,12.949,4.352,8.044H0L5.779,20.5v4.612H9.837V20.348l5.781-12.3Z",
    transform: "translate(0 -4.908)",
    fill: "#424448"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.032,
    height: 17.072,
    transform: "translate(20.916 3.135)",
    fill: "#424448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.32,8.044V25.116H92.6v-3.1H84.433V8.044Z",
    transform: "translate(-49.012 -4.908)",
    fill: "#424448"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.143,8.044c5.352,0,8.028,2.413,8.028,8.538,0,6.254-2.7,8.534-8.028,8.534H126.1V8.044Zm.288,13.918c2.972,0,3.66-1.4,3.66-5.38,0-4.087-.745-5.41-3.792-5.41h-2.172v10.79Z",
    transform: "translate(-76.945 -4.908)",
    fill: "#424448"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.029,
    height: 17.072,
    transform: "translate(69.059 3.135)",
    fill: "#424448"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.13,22.36l7.849-11.24-2.655.131h-4.98V8.043H214.7v2.6L206.77,22.017l2.731-.133h5.489v3.232H202.13Z",
    transform: "translate(-123.342 -4.908)",
    fill: "#424448"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.626,36.857a.247.247,0,0,0,.032.383l5.243,3.81c.131.095.2.047.147-.107l-2.261-6.954a.163.163,0,0,0-.3-.069Z",
    transform: "translate(-173.026 -20.656)",
    fill: "#e30032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.311,7.194a.178.178,0,0,0,.2-.251L277.295.116c-.05-.154-.131-.154-.181,0l-2.072,6.371a.227.227,0,0,0,.2.308Z",
    transform: "translate(-167.825 0)",
    fill: "#e30032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.441,20.064c.131-.1.105-.173-.056-.173H253.169c-.161,0-.187.078-.056.173l6.263,4.549a.431.431,0,0,1,.147.452l-2.389,7.361c-.05.154.016.2.147.107l6.261-4.548.475-.345,3.687-2.68.475-.345Z",
    transform: "translate(-154.402 -12.138)",
    fill: "#e30032"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.024 7.878)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.707,
    height: 4.987,
    transform: "translate(0 0)",
    fill: "url(#e)"
  })))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.85,25.144V8.085h4.023v6.438h5.91V8.085h4.025v17.06h-4.025V17.728h-5.91v7.416Z",
    transform: "translate(-199.448 -4.933)",
    fill: "#424448"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M389.393,23a8.519,8.519,0,0,1-10.812,0c-1.667-1.586-2.379-4.053-2.379-6.964s.712-5.377,2.379-6.967a8.523,8.523,0,0,1,10.812,0c1.67,1.59,2.384,4.053,2.384,6.967s-.714,5.378-2.384,6.964m-8.079-2.355a3.6,3.6,0,0,0,5.351,0c.712-.9,1.085-2.359,1.085-4.608s-.373-3.71-1.085-4.61a3.6,3.6,0,0,0-5.351,0c-.713.9-1.086,2.359-1.086,4.61s.373,3.706,1.086,4.608",
    transform: "translate(-229.564 -4.353)",
    fill: "#424448"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M433.811,8.085v13.96h8.157v3.1H429.7V8.085Z",
    transform: "translate(-262.21 -4.933)",
    fill: "#424448"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M480.07,8.085c5.352,0,8.026,2.413,8.026,8.53,0,6.25-2.7,8.53-8.026,8.53h-6.037V8.085Zm.293,13.908c2.967,0,3.654-1.405,3.654-5.378,0-4.079-.742-5.4-3.788-5.4h-2.171V21.993Z",
    transform: "translate(-289.261 -4.933)",
    fill: "#424448"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.027,
    height: 17.06,
    transform: "translate(204.117 3.151)",
    fill: "#424448"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M558.775,25.144l-4.4-7.259-1.827-3.5-.133.054.159,5.35v5.351h-3.68V8.085h4.023l4.294,7.418,2.221,4.211.107-.055-.13-5.243V8.085h3.734v17.06Z",
    transform: "translate(-334.942 -4.933)",
    fill: "#424448"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M610.57,11.293a9.87,9.87,0,0,0-4.4-1.032c-2.937,0-4.183,1.509-4.183,5.773,0,4.236,1.084,5.721,3.866,5.721a6.515,6.515,0,0,0,2.649-.5V17.12l-3.391-.292V14.179h7.258V24.3l-2.016.45-1.481-.9L605.8,24.933h-.687c-4.37,0-7.207-2.513-7.207-8.9,0-6.147,2.889-8.9,8.266-8.9a11.193,11.193,0,0,1,5.644,1.456Z",
    transform: "translate(-364.85 -4.353)",
    fill: "#424448"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYildizHolding);
export default __webpack_public_path__ + "static/media/yildiz-holding.a183731940141cebb384727b703496c2.svg";
export { ForwardRef as ReactComponent };